import React from 'react'
import Shimmer from './Shimmer'
import SkeletonElement from './SkeletonElement'

const SkeletonPlan = ({ theme }: any) => {
  const themeClass = theme || 'light'

  return (
    <div className={`skeleton-wrapper ${themeClass}`}>
      <div className="skeleton-article">
        <SkeletonElement type="plan" />
      </div>
      <Shimmer />
    </div>
  )
}

export { SkeletonPlan }
